"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGolfTransfer_ClientComplete = void 0;
const isGolfTransfer_ClientComplete = (details) => {
    if (!details)
        return false;
    if (details === null)
        return false;
    if (details.requested_arrival_time)
        return true;
    return false;
};
exports.isGolfTransfer_ClientComplete = isGolfTransfer_ClientComplete;
